import statuses from 'statuses';

export default {
  methods: {
    /**
      * Delete a resource by ID
      */
    delete() {
      let statusName = 'Accepted';
      fetch(
        this.fetchUrl(this.endpoint, this.formData, this.method), this.fetchOptions(this.formData, this.method)
      ).then( (res) => {
        if (res.status == statuses[statusName]) {
          return res.json();
        } else {
          throw new Error(`Resource could not be deleted: ${res.status} status code (Not ${statusName})`);
        }
      }).then( (json) => {
        this.$emit('resource:deleted', this.resourceId);
      }).catch( (err) => {
        console.error(err);
      });
    }
  }
};
